export const formatText = (text, caseFormat) => {
	const normalizedFormat = caseFormat?.toLowerCase();
  switch (normalizedFormat) {
    case "upper":
		case "uppercase":
      return text.toUpperCase();
    case "lower":
		case "lowercase":
      return text.toLowerCase();
    case "camel":
		case "camelcase":
      return text
        .toLowerCase()
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
          index === 0 ? match.trim().toLowerCase() : match.trim().toUpperCase()
        )
        .replace(/\s+/g, ""); // Remove espaços extras
    case "pascal":
    case "pascalcase":
      return text
        .toLowerCase()
        .replace(/(?:^|\s|_|-)(\w)/g, (match, group) => group.toUpperCase());
    case "kebab":
		case "kebabcase":
      return text
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(/-+/g, "-");
    case "snake":
		case "snakecase":
      return text
        .toLowerCase()
        .replace(/[\s-]+/g, "_")
        .replace(/_+/g, "_");
    default:
      return text;
  }
};